import { useRoute } from "eddev/routing"
import { useEffect, useRef } from "react"

export const HashAnchorScroll = () => {
  const route = useRoute()
  const scrollTimer = useRef<number | null>(null)

  // if there is an anchor in the URL, scroll to it
  useEffect(() => {
    let links: NodeListOf<HTMLAnchorElement> | null = null

    const scrollToHash = (e: Event) => {
      if (e.target instanceof HTMLAnchorElement) {
        const href = e.target.getAttribute("href")
        if (href && href.startsWith("#")) {
          const element = document.querySelector(href)
          if (element) {
            e.preventDefault()
            element.scrollIntoView({ behavior: "smooth", block: "center" })
          }
        }
      }
    }

    if (typeof window !== "undefined") {
      links = document.querySelectorAll(".rich-text-group a, .wp-block-table a")

      links.forEach((link) => {
        link.addEventListener("click", scrollToHash)
      })

      if (scrollTimer.current) {
        window.clearTimeout(scrollTimer.current)
      }
      scrollTimer.current = window.setTimeout(() => {
        const hash = window.location.hash
        if (hash) {
          const element = document.querySelector(hash)
          if (element) {
            element.scrollIntoView({ behavior: "smooth", block: "center" })
          }
        }
      }, 200)
    }

    return () => {
      if (links) {
        links.forEach((link) => {
          link.removeEventListener("click", scrollToHash)
        })
      }
      if (scrollTimer.current) {
        window.clearTimeout(scrollTimer.current)
      }
    }
  }, [route.pathname])

  return null
}
